import { getNotification, putNotification, postNotification, managedUsers } from '@/services/api';

export default {
    actions: {
        async fetchNotification({ commit }, id) {
            const result = await getNotification(id);
            commit('setNotification', result);
        },
        async setNotification({ commit }, payload) {
            commit('setNotification', payload);
        },
        async saveNotification({ commit }, payload) {
            const notification = await postNotification(payload);
            commit('setNotification', notification);
        },
        async updateNotification({ commit }, payload) {
            const notification = await putNotification(payload.id, payload.data);
            commit('setNotification', notification);
        },
        async setCreatedNotification({ commit }, notification) {
            commit('setCreatedNotification', notification);
        },
        async setSubscribers({ commit }) {
            const result = await managedUsers();
            commit('setSubscribers', result);
        },
    },
    mutations: {        
        setNotification(state, updateNotification) {
            state.notification = updateNotification;
        },
        setCreatedNotification(state, createdNotification) {
            state.createdNotification = createdNotification;
        },
        setSubscribers(state, updatesetSubscribers) {
            state.subscribers = updatesetSubscribers;
        },
    },
    state: {
        notification : null,
        createdNotification : null,
        subscribers : [],
    },
    getters: {
        getNotification(state) {
            return state.notification;
        },
        getCreatedNotification(state) {
            return state.createdNotification;
        },
        getSubscribers(state) {
            return state.subscribers;
        },
        getSystemSubscribers(state) {
            return state.subscribers.filter((subscriber) => subscriber.isSystem);
        },
    },
}